import { render, staticRenderFns } from "./connection-tester-btn.vue?vue&type=template&id=381ce844"
import script from "./connection-tester-btn.vue?vue&type=script&lang=js"
export * from "./connection-tester-btn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports